import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SettingsItems from 'containers/Settings/ChildPages/SettingsItems';
import { connect } from 'react-redux';
import { List } from 'immutable';
import TextField from '@mui/material/TextField';

import * as budgetsSelectors from 'companion-app-components/flux/budgets/budgetsSelectors';
import * as budgetsActions from 'companion-app-components/flux/budgets/budgetsActions';
import * as categoryGroupListsSelectors from 'companion-app-components/flux/category-group-lists/categoryGroupListsSelectors';
import { mkBudgetRecord } from 'companion-app-components/flux/budgets/budgetsTypes';
import { v4 as uuidv4 } from 'uuid';

import { mkBudgetItemArray } from '../../utils';

const dataDictionary = List([
  { id: 'name',
    detailsOnly: false,
    type: 'string',
    label: 'Name',
    flex: 2,
    editable: true,
    unique: false,
    component: TextField },
]);

class SettingsBudgets extends PureComponent {

  makeImmutableBudget = (defaults) => {

    // We need to find the original record that has LOTS of fields in it, more than we allow to be edited here
    // and we need to reinsert those fields for the update that will occur, otherwise the mkBudgetRecord will insert
    // default values to override the current values in the store
    let baseDefaults = defaults;
    if (defaults.id) {
      const originalRecord = this.props.budgets.get(defaults.id);
      if (originalRecord) {
        baseDefaults = { ...originalRecord.toJS(), ...defaults };
      }
    }

    return mkBudgetRecord({
      ...baseDefaults,
    });

  };

  // For a new item we need to seed it with a clientId and with a catGroupListId
  createItem = (item) => {
    const newItem = item.set('clientId', uuidv4().toUpperCase()).set('catGroupListId', this.props.categoryGroupLists.first().id);
    this.props.dispatchCreateBudgetAction(newItem);
  };

  deleteItems = (items) => {
    this.props.dispatchDeleteBudgetsAction(items.map((item) => item.set('isDeleted', true)));
    return true;
  };

  render() {

    return (
      <SettingsItems
        dataDictionary={dataDictionary}
        items={this.props.budgets}
        mkImmutableItem={this.makeImmutableBudget}
        mkItemArray={mkBudgetItemArray}
        getItems={this.props.dispatchGetBudgetsAction}
        deleteItems={this.deleteItems}
        createItem={this.createItem}
        updateItem={this.props.dispatchUpdateBudgetAction}
        title="Budgets"
        titleIconName="budgets"
        titleIconBackground="#555"
      />
    );
  }
}

SettingsBudgets.propTypes = {
  budgets: PropTypes.object,
  dispatchGetBudgetsAction: PropTypes.func,
  dispatchDeleteBudgetsAction: PropTypes.func,
  dispatchCreateBudgetAction: PropTypes.func,
  dispatchUpdateBudgetAction: PropTypes.func,
  categoryGroupLists: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    budgets: budgetsSelectors.getBudgets(state),
    categoryGroupLists: categoryGroupListsSelectors.getCategoryGroupLists(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetBudgetsAction: () => dispatch(budgetsActions.getBudgetsAction()),
    dispatchCreateBudgetAction: (data) => dispatch(budgetsActions.createBudgetsAction([data], { undo: { userMessage: 'New budget created.' } })),
    dispatchUpdateBudgetAction: (data) => dispatch(budgetsActions.updateBudgetAction(data, { undo: { userMessage: 'Budget name updated' } })),
    dispatchDeleteBudgetsAction: (data) => dispatch(budgetsActions.deleteBudgetsAction(data, { undo: { userMessage: 'Multiple Budgets deleted' } })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsBudgets);
